


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, EMPTY } from 'rxjs';
import { tap, map, switchMap, take, catchError, withLatestFrom, filter, concatMap, mergeMap } from 'rxjs/operators';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { get, mergeWith } from 'lodash';

import { getValue } from '@app/shared/utils/feature-utils';
import * as fromStore from '@app/core/store';
import * as fromMaster from '../store/master-comp-array-form-clients.actions';
import { ActionHandler } from '@app/core/components/actions/action.handler';
import { MessagesService } from '@app/core/services/messages/message.service';
import { ClientService } from '@services-api/client.service';
import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;

@Injectable()
export class MasterCompArrayFormClientsEffects {
  constructor(
    private actions$: Actions,
    private actionHandler: ActionHandler,
    private store: Store<fromStore.State>,
    private message: MessagesService,
    private httpClient: HttpClient,
    private service: ClientService,
  ) { }

  initValueService = (payload: any) => {
    const code = payload.code;
    if (typeof code === "undefined") {
      return of({})
        ;
    }
    if (payload.parentCtx && payload.parentCtx.roleName) {
      return this.store.select(fromStore.selectRoleValue, {
        ...payload.parentCtx,
        code
      });
    } else {

      return of({})
        ;
    }
  };

  initValue$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(fromMaster.initValueAction),
      switchMap(payload => {
        return this.initValueService(payload).pipe(
          map(
            result =>
              fromMaster.initValueSuccessAction({
                ...payload,

                result

              })
          ),
          catchError(error =>
            of(fromMaster.initValueFailAction({ ...payload, error }))
          )
        );
      }))
  );

  fetchasdfghfghfghPossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'asdfghfghfgh'),
    switchMap(payload => {
      const params = {};
      return this.httpClient.get<any>(`${BASE_PATH}/bff/createUserConfig/clients`, { params })

        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: ['fantasyName']
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );










}


